export default class ScheduleTabs {
  constructor(element) {
    this.element = element;
    this.dataTarget = this.element.getAttribute('data-tab-target');
    this.tabMenus = this.element.querySelectorAll('[data-tab-for]');
    this.tabContents = document.querySelectorAll(this.dataTarget);
    this.currentTab = null;
  }

  init() {
    this.bindClick();
  }

  bindClick() {
    for(var idx = 0; idx < this.tabMenus.length; idx++) {
      this.tabMenus[idx].addEventListener('click', function(event) {
        event.preventDefault();
        this.currentTab = event.target;
        this.toggleActive(event.target);
      }.bind(this));
    }
  }

  toggleActive(target) {
    this.updateDate(target.innerText);
    this.hideDatePicker();
    var idx = 0;
    for(idx = 0; idx < this.tabMenus.length; idx++) {
      this.tabMenus[idx].classList.remove('tab-active');
    }

    for(idx = 0; idx < this.tabContents.length; idx++) {
      this.tabContents[idx].classList.remove('tab-active');
    }

    document.querySelector("[data-tab-for='" + target.getAttribute('data-tab-for') + "']").classList.add('tab-active');
    document.querySelector(target.getAttribute('data-tab-for')).classList.add('tab-active');
  }

  updateDate(date){
    document.querySelector('.b-livestreaming-daily-schedule__date-label').innerText = date;
  }

  hideDatePicker(){
    let datePickerElement = document.querySelector('.b-livestreaming-daily-schedule__date-picker');
    if (datePickerElement)
      datePickerElement.classList.add('b-livestreaming-daily-schedule__date-picker--hide');
    this.changeDateIconToDown();
  }

  changeDateIconToDown(){
    let dateIcon = document.querySelector('.b-livestreaming-daily-schedule__date-icon');
    if (dateIcon) {
      dateIcon.classList.remove('b-livestreaming-daily-schedule__date-icon--up');
      dateIcon.classList.add('b-livestreaming-daily-schedule__date-icon--down');
    }
  }
}
